import React, { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { Loader2 } from 'lucide-react';
import { googleLoginApi } from '../services/apiService';
import { UserProfile } from '../types';

interface GoogleLoginButtonProps {
  onSuccess: (user: UserProfile) => void;
  onError: (errorMsg: string) => void;
  disabled?: boolean;
}

export const GoogleLoginButton: React.FC<GoogleLoginButtonProps> = ({
  onSuccess,
  onError,
  disabled,
}) => {
  const [loading, setLoading] = useState(false);

  const handleIdToken = async (idToken: string) => {
    setLoading(true);
    try {
      const res = await googleLoginApi(idToken);
      if (res.user) {
        onSuccess(res.user);
      } else {
        onError('Không thể lấy thông tin đăng nhập từ Google.');
      }
    } catch (err: any) {
      onError(err.message || 'Đăng nhập bằng Google thất bại. Vui lòng thử lại.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full flex flex-col items-center justify-center my-3 py-1">
      {loading ? (
        <div className="w-full py-3 px-4 bg-slate-50 text-slate-700 font-medium text-sm border border-slate-200 rounded-xl flex items-center justify-center space-x-2">
          <Loader2 className="w-4 h-4 animate-spin text-blue-600" />
          <span>Đang xác thực với Google...</span>
        </div>
      ) : (
        <div className={`w-full flex justify-center ${disabled ? 'pointer-events-none opacity-50' : ''}`}>
          <GoogleLogin
            onSuccess={(credentialResponse) => {
              if (credentialResponse.credential) {
                handleIdToken(credentialResponse.credential);
              } else {
                onError('Không nhận được mã xác thực Google (ID Token).');
              }
            }}
            onError={() => {
              onError('Đăng nhập bằng Google không thành công hoặc bị hủy.');
            }}
            text="signin_with"
            locale="vi"
            theme="outline"
            shape="rectangular"
            size="large"
            width="360"
          />
        </div>
      )}
    </div>
  );
};


